// Palette tokens from art_refs/ART_DIRECTION.md §2. Use these, never ad-hoc hex.
// Gold and teal are the two poles; saturated red/magenta LIGHT is reserved for gameplay signals.

export const PAL = {
  // air and light
  hazeGold: 0xfac77d, hazeLight: 0xfed288, sunCore: 0xffe6b0,
  shadowTeal: 0x3e5a4e, deepShadow: 0x22332c,
  skyTop: 0x3a749b, horizon: 0xf2d9a8,
  // ground
  grassGold: 0xd99423, grassGoldTip: 0xe7b86d, grassGreen: 0x9bc349, grassGreenDeep: 0x78a132,
  underside: 0x204415, cobble: 0xd6c79d, dirt: 0xb2a981,
  // appliance inks
  paperCream: 0xe6e0cd, warmCream: 0xf0e6c8, tan: 0xd5c094,
  toasterRed: 0xd44f2b, plum: 0x7f5747, safetyOrange: 0xd9662b, brick: 0xb2613d,
  washerBlue: 0x69757a, washerBand: 0x5f7fa6, mint: 0xbdd2a2, olive: 0x9a8043, army: 0x7b6436,
  rust: 0xa84a2a, inkDark: 0x383019, graffiti: 0xb03a6a,
  bulldozer: 0xe3a21f, avocado: 0x8a9a4b, robinEgg: 0x8fc7c3, chrome: 0xc9c4be,
  // town
  clapTeal: 0x4e9a9a, seaGreen: 0x6fb0a0, wood: 0x8d7a5a, rustRoof: 0x8a4e2e,
  // player kit
  gunmetal: 0x433d3c, steel: 0xa2998c, denim: 0x4d5a6b, brass: 0xc08a3e, scarfBrown: 0x5b4130,
  gearCream: 0xe7e6e5, gearTag: 0xd8312b,
  // train
  verdigris: 0x6e8c88, verdigrisShadow: 0x3f5553, copper: 0xb0705a, copperShadow: 0x6e4234,
  brassTrim: 0xc9a15a, underHull: 0x2c2820, windowGlow: 0xffc870, thrusterCore: 0xffe6b0, thrusterRing: 0xff8a3d,
  // gameplay signals (emissive only)
  primeMagenta: 0xff3cac, primeAmber: 0xffb03a, laserRed: 0xff3b2f, hurtRed: 0xff3b2f,
  shieldBlue: 0x7fd6ff, hyperMagenta: 0xe23cff,
} as const;

/** Player slot colours: the scarf, posse tab and name tag (LIBERTY in the art guide §7). */
export const SLOT_COLORS = [0xc4553a, 0x3fa7a0, 0xd8a83a, 0x8a6ad0] as const;
export const SLOT_CSS = ['#c4553a', '#3fa7a0', '#d8a83a', '#8a6ad0'] as const;
